import { IFlashcardCollection } from '@sdk/contracts';
import { create as createStore } from 'zustand';

interface IStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  collectionForm: Partial<IFlashcardCollection> | null;
  setCollectionForm: (form: Partial<IFlashcardCollection> | null) => void;
  flashcardId: string | null;
  setFlashcardId: (flashcardId: string | null) => void;
}

export const useCollectionForm = createStore<IStore>(set => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => {
    set({ isOpen });
  },
  collectionForm: null,
  setCollectionForm: (form: Partial<IFlashcardCollection> | null) => {
    set({ collectionForm: form });
  },
  flashcardId: null,
  setFlashcardId: (flashcardId: string | null) => {
    set({ flashcardId });
  }
}));
